export default "/react/logoCalltracking-cb7bcb60.png";